var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0044EB",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100.787 100.787",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.288,94.894h-7.121V90.06c0-0.275-0.224-0.5-0.5-0.5s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5 s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5 s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5 s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5s-0.5,0.225-0.5,0.5v4.834h-9V90.06c0-0.275-0.224-0.5-0.5-0.5 s-0.5,0.225-0.5,0.5v4.834H3V83.561h4.016c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5 s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5 s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5 s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5H3v-9h4.016c0.276,0,0.5-0.224,0.5-0.5 s-0.224-0.5-0.5-0.5H3V4.394c0-0.829-0.672-1.5-1.5-1.5S0,3.564,0,4.394v92c0,0.828,0.672,1.5,1.5,1.5h97.787 c0.828,0,1.5-0.672,1.5-1.5S100.116,94.894,99.288,94.894z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.644,
    y: 16.497,
    width: 10.25,
    height: 67.795
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.394,
    y: 42.791,
    width: 10.25,
    height: 41.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.895,
    y: 28.541,
    width: 10.25,
    height: 55.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.395,
    y: 35.291,
    width: 10.25,
    height: 49
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytics);
export default __webpack_public_path__ + "static/media/data_analytics.33b7785b3ff17e2384984d176ced115c.svg";
export { ForwardRef as ReactComponent };